// extracted by mini-css-extract-plugin
export default {"alertBox":"alertBoxeKxo0"};